import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import AirportDetail from './AirportDetail';
import * as airportActions from './../../../../../actions/airportAction';

const mapStateToProps = state => {
    return {
        airportState: state.airportReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAirportDetail: (id) => dispatch(airportActions.getAirportDetail(id)),
        setAirportDetail: (airport) => dispatch(airportActions.setAirportDetail(airport)),
        updateAirportDetail: (airport) => dispatch(airportActions.updateAirportDetail(airport)),
        createAirportDetail: (airport) => dispatch(airportActions.createAirportDetail(airport)),
        createAirportTranslate: (airport, language) => dispatch(airportActions.createAirportTranslate(airport, language)),
        updateAirportTranslate: (airport, language) => dispatch(airportActions.updateAirportTranslate(airport, language)),
        deleteAirportTranslate: (airport, refreshParams) => dispatch(airportActions.deleteAirportTranslate(airport, refreshParams)),
        getToAirportList: (id) => dispatch(airportActions.getToAirportList(id))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AirportDetail));
